<div class="scroll-content" style="flex: none !important;margin-top: 60px !important">
  <div id="content-list" class="list list-md">
    @for (option of options(); track option) {
      <app-button-radio
        [label]="option.label"
        [value]="option.value"
        [onClick]="onOptionSelect.bind(this)"
        [selected]="selected()"
        />
    }
  </div>
</div>
